module.exports = __webpack_public_path__ + "img/top_bg.767e473e.png";